export type DesignId = 'classic' | 'air' | 'glass' | 'aurora' | 'neo' | 'ukraine' | 'leaf' | 'vyshyvanka';

/** Стиль плиток категорий на главной: фото или эмодзи-значки */
export type CategoryStyle = 'photo' | 'emoji';

export interface DesignInfo {
  id: DesignId;
  nameKey: string;
  /** Градиент для мини-превью в настройках */
  swatch: string;
}

// «Украина» первым: это дизайн по умолчанию для новых пользователей —
// сине-жёлтый, под флаг. Существующие дизайны остаются доступны.
export const DESIGNS: DesignInfo[] = [
  { id: 'ukraine', nameKey: 'design.ukraine', swatch: 'linear-gradient(180deg, #0057B7 0%, #0057B7 50%, #FFD700 50%, #FFD700 100%)' },
  { id: 'leaf', nameKey: 'design.leaf', swatch: 'linear-gradient(135deg, #e8f5e9 0%, #2E8B57 100%)' },
  { id: 'vyshyvanka', nameKey: 'design.vyshyvanka', swatch: 'linear-gradient(135deg, #FAF3E7 0%, #C0392B 100%)' },
  { id: 'neo', nameKey: 'design.neo', swatch: 'linear-gradient(135deg, #ff4d5f 0%, #0b0d12 100%)' },
  { id: 'classic', nameKey: 'design.classic', swatch: 'linear-gradient(135deg, #d63047 0%, #1a1a2e 100%)' },
  { id: 'air', nameKey: 'design.air', swatch: 'linear-gradient(135deg, #eef0ff 0%, #5b5fe9 100%)' },
  { id: 'glass', nameKey: 'design.glass', swatch: 'linear-gradient(135deg, #6366f1 0%, #d946ef 55%, #fb7185 100%)' },
  { id: 'aurora', nameKey: 'design.aurora', swatch: 'linear-gradient(135deg, #0b0f1a 0%, #8b5cf6 60%, #22d3ee 100%)' },
];

const STORAGE_KEY = 'barter-design';
const CAT_STYLE_KEY = 'barter-category-style';
const MIGRATION_KEY = 'barter-design-migrated';

// Разовая миграция: classic раньше был дефолтом и осознанно его почти никто
// не выбирал. Сейчас дефолт — «Украина»: свежие установки получают его.
// Явный выбор air/glass/aurora/neo уважаем. Флаг гарантирует, что возврат
// на classic из настроек после миграции прилипнет.
function migrateLegacyDefault(): void {
  try {
    if (localStorage.getItem(MIGRATION_KEY)) return;
    localStorage.setItem(MIGRATION_KEY, '1');
    if (localStorage.getItem(STORAGE_KEY) === 'classic' || !localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, 'ukraine');
    }
  } catch {}
}

export function getDesign(): DesignId {
  migrateLegacyDefault();
  try {
    const stored = localStorage.getItem(STORAGE_KEY) as DesignId | null;
    if (stored && DESIGNS.some((d) => d.id === stored)) return stored;
  } catch {}
  return 'ukraine';
}

export function applyDesign(id: DesignId) {
  document.documentElement.setAttribute('data-design', id);
}

export function saveDesign(id: DesignId) {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {}
  applyDesign(id);
}

export function getCategoryStyle(): CategoryStyle {
  try {
    const stored = localStorage.getItem(CAT_STYLE_KEY) as CategoryStyle | null;
    if (stored === 'photo' || stored === 'emoji') return stored;
  } catch {}
  return 'photo';
}

export function applyCategoryStyle(_style: CategoryStyle) {
  // Стиль плиток застосовується React-класом category-badge--photo (TelegramContext);
  // окремий атрибут на <html> не потрібен.
}

export function saveCategoryStyle(style: CategoryStyle) {
  try {
    localStorage.setItem(CAT_STYLE_KEY, style);
  } catch {}
  applyCategoryStyle(style);
}
